import { render, staticRenderFns } from "./MitManageReservationsSetupPage.vue?vue&type=template&id=a00c5bf8&scoped=true"
import script from "./MitManageReservationsSetupPage.vue?vue&type=script&lang=js"
export * from "./MitManageReservationsSetupPage.vue?vue&type=script&lang=js"
import style0 from "./MitManageReservationsSetupPage.vue?vue&type=style&index=0&id=a00c5bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c5bf8",
  null
  
)

export default component.exports